import { useEffect, useRef } from "react";

import { MotionGlobalConfig, animate, useReducedMotion } from "motion/react";

import { formatNumber } from "@/lib/format";

/**
 * Raqam avvalgi qiymatdan yangisigacha "sanab" chiqadi (web ilovadagi kabi).
 *
 * React chizadigan matn — doim YAKUNIY qiymat: skrinrider, test va
 * animatsiyasiz rejim oraliq raqamni ko'rmaydi. Harakat faqat DOM matnini
 * vaqtincha almashtiradi.
 */
export function AnimatedNumber({
  value,
  format = formatNumber,
  duration = 0.9,
}: {
  value: number;
  format?: (value: number) => string;
  duration?: number;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const from = useRef(0);
  const reduced = useReducedMotion();

  useEffect(() => {
    const node = ref.current;
    const start = from.current;
    from.current = value;
    if (!node || reduced || MotionGlobalConfig.skipAnimations || start === value) return;
    const controls = animate(start, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: latest => {
        node.textContent = format(Math.round(latest));
      },
      onComplete: () => {
        node.textContent = format(value);
      },
    });
    return () => controls.stop();
  }, [value, duration, reduced, format]);

  return (
    <span ref={ref} className="tabular-nums">
      {format(value)}
    </span>
  );
}
